<template>
  <div>
    <div class="w-full mb-4">
      <p class="text-sm text-gray-500 leading-relaxed text-justify">{{ form.description }}</p>
    </div>


    <div class="flex flex-col space-y-3">
      <p>Configuración tabla resumen</p>
      <div class="space-y-2">
        <label class="font-medium text-gray-700">Mostrar avance de progreso de: </label>
        <b-select v-model="form.settings.showGroupProgress" expanded
          class="w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
        >
            <option v-for="item in types" :key="item.value" :value="item.value">
                {{ item.label }}
            </option>
        </b-select>
      </div>

      <div class="space-y-2">
        <label class="font-medium text-gray-700">Seleccione los grupos a mostrar</label>
        <treeselect v-model="form.settings.customGroups"
          :multiple="true"
          :options="getFilteredGroups"
          :disabled="form.settings.showGroupProgress != 'custom'"
          :normalizer="treeselectNormalizer"
          :placeholder="$t('select_group_menu')" append-to-body
          class="w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
        />
      </div>

      <div class="space-y-2">
        <!-- <p>Ajustes de fechas para el resumen de avance</p> -->
        <p>Ajustes de fechas a mostrar</p>
        <div class="flex space-x-3">
          <div class="w-1/2">
            <label for="">Primera fecha</label>
            <b-select v-model="form.settings.firstDatePairType" expanded
              class="w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
            >
              <option v-for="item in datesOptions" :key="item.value" :value="item.value">
                  {{ item.label }}
              </option>
            </b-select>
          </div>
          <div class="w-1/2">
            <label for="">Segunda fecha</label>
            <b-select v-model="form.settings.secondDatePairType" expanded
              class="w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
            >
                <option v-for="item in datesOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                </option>
            </b-select>
          </div>
        </div>
        <!-- <div class="flex justify-between items-center w-full mt-2">
          <span class="mr-4">
            Mostrar la fecha final, de la segunda fecha según se vayan completando las actividades
          </span>
          <b-switch  size="is-small" v-model="form.settings.showEndDateOnCompletion"/>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import { saveConfigPage } from '../services/report-detail.service.js';

export default {
  name: "PageSummaryConfigForm",

  components: {
    Treeselect,
  },

  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    activityGroups: {
      type: Array,
      default: () => ([])
    },
    reportConfigs: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      form: { ... this.initialData },
      types: [
          { value: 'parent', label: 'Grupos padres' },
          { value: 'children', label: 'Grupos hijos' },
          { value: 'custom', label: 'Personalizado' }
      ],
      datesOptions: [
        {value: 'scheduled', label: 'Fecha programada'},
        {value: 'current', label: 'Fecha actual'},
        {value: 'real', label: 'Fecha real'},
      ]
    };
  },

  computed: {
    getFilteredGroups() {
      function filterTree(nodes, type) {
          if (type === 'parent') {
              return nodes
                  .filter(node => !node.parent_id)
                  .map(node => ({
                      ...node,
                      children: undefined
                  }));
          } else if (type === 'children') {
              const flattenChildren = (arr) => {
                  let result = [];
                  arr.forEach(node => {
                      if (node.parent_id) {
                          result.push({ ...node, children: undefined });
                      }
                      if (node.children) {
                          result = result.concat(flattenChildren(node.children));
                      }
                  });
                  return result;
              };
              return flattenChildren(nodes);
          }
          return nodes;
      }

      return filterTree(this.activityGroups, this.selectedType);
    },
  },

  methods: {
    submit() {
      saveConfigPage(this.form, this.reportConfigs)
      this.$emit('epc-save', this.form);
    },

    treeselectNormalizer(n) {
      return { id: n.id, label: n.label, children: n.children }
    },
  }
}
</script>